import { WashboxApiClient } from "./client";
import { keycloakSession } from "@/auth/keycloak-session";
import { runtimeConfig } from "@/config/runtime";

export const washboxApi = new WashboxApiClient(runtimeConfig.apiBaseUrl, (forceRefresh) =>
  keycloakSession.getAccessToken(forceRefresh),
);
